export default __webpack_public_path__ + "locales/si/RoomLogoCover.json?hash=02b1fb70c54bd17498cf6e439090c420";